import { DatePipe } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon, IonText } from '@ionic/angular';

import { DiscussionListItem } from '../../../models/discussion.models';
import { OverduePipe } from '../../../pipes/overdue.pipe';
import { DiscussionListItemParticipantsComponent } from '../../discussion-participants/discussion-list-item-participants.component';
import { DiscussionStatusBadgeComponent } from '../../discussion-status-badge/discussion-status-badge.component';

@Component({
  selector: 'nty-discussion-list-item',
  imports: [
    IonIcon,
    IonText,
    DatePipe,
    DiscussionListItemParticipantsComponent,
    OverduePipe,
    DiscussionStatusBadgeComponent,
  ],
  template: `
    <div class="discussion-list-item-header">
      <h2 class="terra-body-bold discussion-title">{{ discussion.title }}</h2>

      <nty-discussion-status-badge [discussion]="discussion" />

      <div class="discussion-list-item-due-date">
        @if (discussion | overdue) {
          <span class="discussion-due-date-alert">
            <ion-icon aria-hidden="true" name="alert-outline" />
          </span>
          <ion-text class="terra-body danger-text">{{ discussion.dueDate | date: 'MMM d' }}</ion-text>
        } @else {
          <ion-text class="terra-body due-date">{{ discussion.dueDate | date: 'MMM d' }}</ion-text>
        }
      </div>
    </div>

    <nty-discussion-list-item-participants [discussion]="discussion" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'terra';

      :host {
        width: 100%;
      }

      .due-date {
        color: terra.color(text, light);
      }

      .discussion-list-item-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 3px;
        margin-top: 24px;
        margin-bottom: 13px;

        h2.discussion-title {
          margin: 0;
          max-width: 75%;
          display: -webkit-box;
          line-clamp: 3;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          color: terra.color(text);
        }

        .discussion-list-item-due-date {
          display: flex;
          flex-basis: 100%;
          align-items: center;
          gap: 6px;
        }

        .discussion-due-date-alert {
          display: inline-block;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          background-color: terra.color(red);

          ion-icon {
            color: terra.color(white);
          }
        }

        .danger-text {
          color: terra.color(red);
        }
      }
    `,
  ],
})
export class DiscussionListItemComponent {
  @Input({ required: true }) discussion!: DiscussionListItem;
}
